import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Field } from "../miProfile/Field";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useForm } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { unSelectStartup } from "../../../store/startup/startupSlice";
import { editStartup } from "../../helpers";
import { DateInput } from "../DateInput";
import { countryList } from "../../../helpers/countryList";
import { style } from "../../../helpers/editStyle";

export const EditStartup = ({ setHidden, setReloadData }) => {
  const { t } = useTranslation("global");
  const { dataToAction } = useSelector((state) => state.startup);
  const dispatch = useDispatch();
  const [formValues, handleInputChange, reset] = useForm({
    ...dataToAction,
    registrationDate: dataToAction.registrationDate,
    constitutionDate: dataToAction.constitutionDate,
  });

  const {
    name,
    alias,
    country,
    cif,
    registrationDate,
    constitutionDate,
    sector,
    url,
  } = formValues;

  const handleCancel = () => {
    reset();
    dispatch(unSelectStartup());
    setHidden(false);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const { createdAt, deletedAt, ...rest } = formValues;
    await editStartup(
      rest,
      t("startupHeaders.successMsgEdit"),
      t("startupHeaders.errorMsg"),
      t("startupHeaders.dupCifMsg")
    );
    setReloadData((prevState) => !prevState);
    setHidden(false);
  };

  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 9999 }}
      >
        <Box sx={style}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="baseline"
            sx={{ height: "50px" }}
          >
            <Typography
              color="primary"
              marginBottom="10px"
              variant="h5"
              fontWeight={700}
            >
              {t("startupHeaders.editStartup")}
            </Typography>
            <IconButton color="primary" onClick={handleCancel}>
              <CloseRoundedIcon />
            </IconButton>
          </Stack>
          <form
            onSubmit={onSubmit}
            style={{
              padding: "10px 5px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
            }}
          >
            <Stack
              sx={{
                height: "calc(70vh - 200px)",
                overflowY: "auto",
                paddingBottom: "10px",
                paddingRight: "20px",
              }}
            >
              <Grid container direction="row" width="100%">
                <Grid item xs={12} md={6} padding="0 5px">
                  <Field
                    translation="startupHeaders"
                    name={name}
                    title="name"
                    handleInputChange={handleInputChange}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} padding="0 5px">
                  <Field
                    translation="startupHeaders"
                    name={alias}
                    title="alias"
                    handleInputChange={handleInputChange}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" width="100%">
                <Grid item xs={12} padding="0 5px">
                  <Field
                    translation="startupHeaders"
                    name={cif}
                    title="cif"
                    handleInputChange={handleInputChange}
                    required={true}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" width="100%">
                <Grid item xs={12} padding="0 5px">
                  <Typography variant="overline" color="secondary">
                    {t("startupHeaders.country")}
                  </Typography>
                  <Autocomplete
                    disablePortal
                    options={countryList}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="country"
                      />
                    )}
                    value={country}
                    onSelect={handleInputChange}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" width="100%">
                <Grid item xs={12} md={6} padding="0 5px">
                  <DateInput
                    name={registrationDate}
                    title="registrationDate"
                    handleInputChange={handleInputChange}
                    required={true}
                  />
                </Grid>
                <Grid item xs={12} md={6} padding="0 5px">
                  <DateInput
                    name={constitutionDate}
                    title="constitutionDate"
                    handleInputChange={handleInputChange}
                    required={true}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" width="100%">
                <Grid item xs={12} md={6} padding="0 5px">
                  <Field
                    translation="startupHeaders"
                    name={sector}
                    title="sector"
                    handleInputChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6} padding="0 5px">
                  <Field
                    translation="startupHeaders"
                    name={url}
                    title="url"
                    handleInputChange={handleInputChange}
                    required={true}
                  />
                </Grid>
              </Grid>
            </Stack>

            <Stack sx={{ heigth: "80px" }}>
              <Divider sx={{ margin: "30px 0px 15px 0px" }} />

              <Grid container direction="row" width="100%">
                <Grid item xs={12} md={6} padding="0 5px">
                  <Button fullWidth onClick={handleCancel} variant="text">
                    {t("createPassword.cancelButton")}
                  </Button>
                </Grid>
                <Grid item xs={12} md={6} padding="0 5px">
                  <Button fullWidth type="submit" variant="contained">
                    {t("createPassword.principalButton")}
                  </Button>
                </Grid>
              </Grid>
            </Stack>
          </form>
        </Box>
      </Modal>
    </>
  );
};
